<template>
  <div class="" style="height:100%;">
		<img src="../../../assets/feedFlarePage/bg_t.png" class="w100" style="" alt="">
		<div :style="{'min-height': bottomHeight}" class="bottomDom b_b p_s" style="">
			<div v-if="myList.length" class="b_fff b_b d_f f_d_r" style="width: 90%;margin-left: 5%;padding: 5%;justify-content: flex-start;flex-wrap:wrap;border-radius: 40px">
				<div v-for="(item, index) in myList" :key="index" class="d_in t_c v_t" style="width: 30%;margin-bottom: 5%;" :style="{'margin-left': (index)%3 === 0 ? '0' : '5%'}" @click="toUrl(item)">
					<div class="m_b_5 b_r_circle b_FBEBEB d_f f_d_c" style="height: 24vw;align-items: center; justify-content: center;">
						<img :src="item.coverUrl" class="w80 b_r_circle" style="height: 19.2vw" alt="">
					</div>
					<div class="NoWrap w90 d_in font14">
						{{item.name}}
					</div>
				</div>

			</div>
			<div class="font12 b_b m_t_10" style="color: #645757;width: 90%;margin-left: 5%;padding: 5%;line-height: 2;letter-spacing: 1px;">
				<div >审核编号： C-APROM/CN/NINL/0308</div>
				<div >批准日期： 2021/12/20 </div>
				<div >声明：仅供医疗卫生专业人士为了解资讯使用。该等信息不能以任何方式取代专业的医疗指导，也不应被视为诊疗建议。如该等信息被用于了解资讯以外的目的，本站及作者不承担相关责任。</div>
			</div>

		</div>
  </div>
</template>

<script>
export default {
    name: 'errPage',
		data() {
			return {
				bottomHeight: 0,
				myList: []
			}
		},
		mounted(){
			this.$nextTick(() => {
				this.bottomHeight = `calc(100% - ${document.body.clientWidth/1560*884}px)`
				console.log(this.bottomHeight)
			})
			this.getData()
		},
		methods: {
			getData(){
				let data = {
					name: '',
          fromwechat: true,
          pageindex: 1,
          pagesize: 9999
				}
				this.$axiox.getList(this.$commonJs.returnQuery(`/api/ThirdPartyRedirect/query`, data)).then(res => {
          if (res.data) {
            this.myList = res.data
          } else {
            this.myList = []
          }
        })
			},
			toUrl(item){
				window.location.href = item.redirectUrl
			}
		}
}
</script>

<style>
.bottomDom{
	background: url('../../../assets/feedFlarePage/bg_b.png') no-repeat;
	background-size: cover;
	padding-top: 30px;
	padding-bottom: 30px;
	top: 0;
	z-index: 10;
	
	box-shadow: 0px 8.3px 6.64px 0px #00000005,0px 19.95px 15.96px 0px #00000007,0px 37.56px 30.05px 0px #0000000A,0px 67.01px 53.61px 0px #0000000A,0px 125.33px 100.27px 0px #0000000C,0px 300px 240px 0px #00000011;
}
.b_FBEBEB{
	background-color: #FBEBEB;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/feedFlarePage/feedFlarePage.vue